import { BulkRemindSignersJobStatus } from '@dealstack/shared/lib/backendClient';
import type { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

export const BULK_REMIND_SIGNERS_TERMINAL_STATUSES: readonly BulkRemindSignersJobStatus[] = [
	BulkRemindSignersJobStatus.COMPLETED,
	BulkRemindSignersJobStatus.FAILED,
];

export interface ResultBucketRowProps {
	testId: string;
	labelKey: string;
	count: number;
	tMipManage: ReturnType<typeof useTranslationMipManage>;
}
